module.exports = __webpack_public_path__ + "static/screen-classic-laptop-949330e57fd4b625eece4693fb7eafd1.webp";